export const DEFAULT_RELEASE_NOTE_TXT = "Please refer external Release Notes."
export const PARSING_ERROR_MESSAGE = "Failed to parse a special character in the release note entry."


// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/publisher_constants.ts